import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import Entity from 'components/AddRemoveTableSortable/types/Entity'
import useInit from './hooks/useInit'
import ModalEditableProps from './types/ModalEditableProps'

interface EditModalProps {
  showModal: boolean
  relationalFieldName: string
  setShowModal: Function
  entityName: string
  formComponent?: React.FunctionComponent<ModalEditableProps>
  row?: Entity
  setInternalCounter: Function
}

const submitRef = React.createRef<HTMLButtonElement>()

const EditModal: React.FunctionComponent<EditModalProps> = (props: EditModalProps) => {
  const [isRequestLoading, setIsRequestLoading] = useState<boolean>(false)
  const [modalBody, setModalBody] = useState<any>('')

  const triggerDataUpdate = () => {
    props.setInternalCounter((prev) => prev + 1)
    handleModalHide()
  }

  useInit({
    row: props.row,
    relationalFieldName: props.relationalFieldName,
    formComponent: props.formComponent,
    setModalBody,
    submitRef,
    setShowModal: props.setShowModal,
    setIsRequestLoading,
    triggerDataUpdate: triggerDataUpdate,
  })

  const handleModalHide = () => {
    setModalBody('')
    props.setShowModal(false)
  }

  return (
    <Modal show={props.showModal} onHide={() => props.setShowModal(false)} animation={true}>
      <Modal.Header closeButton>
        <Modal.Title>Edit {props.entityName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{modalBody}</Modal.Body>
      <Modal.Footer>
        <Button
          variant='secondary'
          onClick={() => {
            handleModalHide()
          }}
        >
          Close
        </Button>
        <Button
          disabled={isRequestLoading}
          type='submit'
          variant='primary'
          onClick={() => {
            if (submitRef.current != null) {
              submitRef.current.click()
            }
          }}
        >
          {isRequestLoading && (
            <>
              <span
                className='spinner-border spinner-border-sm'
                role='status'
                aria-hidden='true'
              ></span>
              &nbsp;
            </>
          )}
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EditModal
